export const checkEquals = (arrayA, arrayB) => {
  if (!arrayA.length || !arrayB.length) return false

  const sortedA = [...arrayA].sort()
  const sortedB = [...arrayB].sort()

  return (
    sortedA.length === sortedB.length &&
    sortedA.every((v, i) => v === sortedB[i])
  )
}

export const checkIncludesAll = (arrayA, arrayB) => {
  if (!Array.isArray(arrayA) || !Array.isArray(arrayB)) return false
  if (!arrayA.length) return false // if A is empty, treat as false

  return arrayA.every((item) => arrayB.includes(item))
}

export const removeArrayAFromArrayB = (arrayA, arrayB) => {
  if (!Array.isArray(arrayA) || !Array.isArray(arrayB)) return []

  return arrayB.filter((item) => !arrayA.includes(item))
}
